// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DeleteModal_backdrop__ae5W7 {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(16, 24, 40, 0.12);
  backdrop-filter: blur(4px);
  padding: 22px;
}

.DeleteModal_modal__jnEdj {
  position: relative;
  width: 570px;
  max-width: 95%;
  background: linear-gradient(135deg, #fff9f8 0%, #ffffff 100%);
  border-radius: 16px;
  padding: 40px 36px;
  box-shadow: 0 25px 50px rgba(15, 23, 42, 0.15), 0 0 0 1px rgba(255, 255, 255, 0.05);
  text-align: center;
  -webkit-font-smoothing: antialiased;
  animation: DeleteModal_modalSlideIn__5QNHu 0.3s ease-out;
}

@keyframes DeleteModal_modalSlideIn__5QNHu {
  from {
    opacity: 0;
    transform: scale(0.95) translateY(-10px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}
.DeleteModal_closeBtn__O8yGf {
  position: absolute !important;
  top: 16px;
  right: 16px;
  width: 44px !important;
  height: 44px !important;
  min-width: 0 !important;
  border-radius: 50% !important;
  background: var(--white) !important;
  box-shadow: 0 8px 20px rgba(17, 24, 39, 0.08) !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  padding: 0 !important;
  cursor: pointer;
  border: none !important;
  transition: all 0.2s ease !important;
}
.DeleteModal_closeBtn__O8yGf:hover {
  background: #f8f9fa !important;
  box-shadow: 0 10px 25px rgba(17, 24, 39, 0.12) !important;
  transform: scale(1.05);
}
.DeleteModal_closeBtn__O8yGf img {
  width: 20px !important;
  opacity: 0.7;
  transition: opacity 0.2s ease;
}
.DeleteModal_closeBtn__O8yGf:hover img {
  opacity: 1;
}

.DeleteModal_iconCircle__uwJJH {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: linear-gradient(135deg, #ffebee 0%, #fce4ec 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 24px;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.6), 0 4px 12px rgba(211, 47, 47, 0.15);
  border: 2px solid #ffcdd2;
  animation: DeleteModal_iconPulse__nGYsn 2s ease-in-out infinite;
}
.DeleteModal_iconCircle__uwJJH img {
  width: 28px;
  height: 28px;
  filter: drop-shadow(0 2px 4px rgba(211, 47, 47, 0.2));
}

@keyframes DeleteModal_iconPulse__nGYsn {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
}
.DeleteModal_title__MBe11 {
  font: var(--h3);
  font-family: var(--font-bodoni-72);
  font-weight: 700;
  font-size: 32px;
  line-height: 38px;
  color: #d32f2f;
  margin: 0 0 8px;
  text-transform: none;
  text-shadow: 0 1px 2px rgba(211, 47, 47, 0.1);
}

.DeleteModal_subtitle__kHy-2 {
  font-size: 16px;
  color: #64748b;
  margin: 0 0 32px;
  line-height: 1.6;
  max-width: 420px;
  margin-left: auto;
  margin-right: auto;
}

.DeleteModal_footer__Oo\\+Wh {
  display: flex;
  justify-content: center;
  gap: 16px;
  margin-top: 8px;
}

@media screen and (max-width: 767px) {
  .DeleteModal_modal__jnEdj {
    padding: 28px 24px;
    width: 90%;
    border-radius: 12px;
  }
  .DeleteModal_closeBtn__O8yGf {
    width: 36px !important;
    height: 36px !important;
    top: 12px;
    right: 12px;
  }
  .DeleteModal_closeBtn__O8yGf img {
    width: 16px !important;
  }
  .DeleteModal_iconCircle__uwJJH {
    width: 56px;
    height: 56px;
    margin-bottom: 20px;
  }
  .DeleteModal_iconCircle__uwJJH img {
    width: 24px;
    height: 24px;
  }
  .DeleteModal_title__MBe11 {
    font-size: 24px;
    line-height: 30px;
  }
  .DeleteModal_subtitle__kHy-2 {
    font-size: 14px;
    margin-bottom: 24px;
  }
  .DeleteModal_footer__Oo\\+Wh {
    flex-direction: column;
    gap: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/atoms/modal/DeleteModal.module.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,wCAAA;EACA,0BAAA;EACA,aAAA;AACD;;AAEA;EACC,kBAAA;EACA,YAAA;EACA,cAAA;EACA,6DAAA;EACA,mBAAA;EACA,kBAAA;EACA,mFACC;EAED,kBAAA;EACA,mCAAA;EACA,wDAAA;AADD;;AAIA;EACC;IACC,UAAA;IACA,wCAAA;EADA;EAGD;IACC,UAAA;IACA,iCAAA;EADA;AACF;AAIA;EACC,6BAAA;EACA,SAAA;EACA,WAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,6BAAA;EACA,mCAAA;EACA,wDAAA;EACA,wBAAA;EACA,8BAAA;EACA,kCAAA;EACA,qBAAA;EACA,eAAA;EACA,uBAAA;EACA,oCAAA;AAFD;AAIC;EACC,8BAAA;EACA,yDAAA;EACA,sBAAA;AAFF;AAKC;EACC,sBAAA;EACA,YAAA;EACA,6BAAA;AAHF;AAMC;EACC,UAAA;AAJF;;AAQA;EACC,WAAA;EACA,YAAA;EACA,kBAAA;EACA,6DAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,sFACC;EAED,yBAAA;EACA,+DAAA;AAPD;AASC;EACC,WAAA;EACA,YAAA;EACA,qDAAA;AAPF;;AAWA;EACC;IACC,mBAAA;EARA;EAUD;IACC,sBAAA;EARA;AACF;AAWA;EACC,eAAA;EACA,kCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,oBAAA;EACA,6CAAA;AATD;;AAYA;EACC,eAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AATD;;AAYA;EACC,aAAA;EACA,uBAAA;EACA,SAAA;EACA,eAAA;AATD;;AAYA;EACC;IACC,kBAAA;IACA,UAAA;IACA,mBAAA;EATA;EAYD;IACC,sBAAA;IACA,uBAAA;IACA,SAAA;IACA,WAAA;EAVA;EAYA;IACC,sBAAA;EAVD;EAcD;IACC,WAAA;IACA,YAAA;IACA,mBAAA;EAZA;EAcA;IACC,WAAA;IACA,YAAA;EAZD;EAgBD;IACC,eAAA;IACA,iBAAA;EAdA;EAiBD;IACC,eAAA;IACA,mBAAA;EAfA;EAkBD;IACC,sBAAA;IACA,SAAA;EAhBA;AACF","sourcesContent":[".backdrop {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n\tbackground-color: rgba(16, 24, 40, 0.12);\r\n\tbackdrop-filter: blur(4px);\r\n\tpadding: 22px;\r\n}\r\n\r\n.modal {\r\n\tposition: relative;\r\n\twidth: 570px;\r\n\tmax-width: 95%;\r\n\tbackground: linear-gradient(135deg, #fff9f8 0%, #ffffff 100%);\r\n\tborder-radius: 16px;\r\n\tpadding: 40px 36px;\r\n\tbox-shadow: \r\n\t\t0 25px 50px rgba(15, 23, 42, 0.15),\r\n\t\t0 0 0 1px rgba(255, 255, 255, 0.05);\r\n\ttext-align: center;\r\n\t-webkit-font-smoothing: antialiased;\r\n\tanimation: modalSlideIn 0.3s ease-out;\r\n}\r\n\r\n@keyframes modalSlideIn {\r\n\tfrom {\r\n\t\topacity: 0;\r\n\t\ttransform: scale(0.95) translateY(-10px);\r\n\t}\r\n\tto {\r\n\t\topacity: 1;\r\n\t\ttransform: scale(1) translateY(0);\r\n\t}\r\n}\r\n\r\n.closeBtn {\r\n\tposition: absolute !important;\r\n\ttop: 16px;\r\n\tright: 16px;\r\n\twidth: 44px !important;\r\n\theight: 44px !important;\r\n\tmin-width: 0 !important;\r\n\tborder-radius: 50% !important;\r\n\tbackground: var(--white) !important;\r\n\tbox-shadow: 0 8px 20px rgba(17, 24, 39, 0.08) !important;\r\n\tdisplay: flex !important;\r\n\talign-items: center !important;\r\n\tjustify-content: center !important;\r\n\tpadding: 0 !important;\r\n\tcursor: pointer;\r\n\tborder: none !important;\r\n\ttransition: all 0.2s ease !important;\r\n\r\n\t&:hover {\r\n\t\tbackground: #f8f9fa !important;\r\n\t\tbox-shadow: 0 10px 25px rgba(17, 24, 39, 0.12) !important;\r\n\t\ttransform: scale(1.05);\r\n\t}\r\n\r\n\timg {\r\n\t\twidth: 20px !important;\r\n\t\topacity: 0.7;\r\n\t\ttransition: opacity 0.2s ease;\r\n\t}\r\n\r\n\t&:hover img {\r\n\t\topacity: 1;\r\n\t}\r\n}\r\n\r\n.iconCircle {\r\n\twidth: 64px;\r\n\theight: 64px;\r\n\tborder-radius: 50%;\r\n\tbackground: linear-gradient(135deg, #ffebee 0%, #fce4ec 100%);\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n\tmargin: 0 auto 24px;\r\n\tbox-shadow: \r\n\t\tinset 0 1px 0 rgba(255, 255, 255, 0.6),\r\n\t\t0 4px 12px rgba(211, 47, 47, 0.15);\r\n\tborder: 2px solid #ffcdd2;\r\n\tanimation: iconPulse 2s ease-in-out infinite;\r\n\r\n\timg {\r\n\t\twidth: 28px;\r\n\t\theight: 28px;\r\n\t\tfilter: drop-shadow(0 2px 4px rgba(211, 47, 47, 0.2));\r\n\t}\r\n}\r\n\r\n@keyframes iconPulse {\r\n\t0%, 100% {\r\n\t\ttransform: scale(1);\r\n\t}\r\n\t50% {\r\n\t\ttransform: scale(1.05);\r\n\t}\r\n}\r\n\r\n.title {\r\n\tfont: var(--h3);\r\n\tfont-family: var(--font-bodoni-72);\r\n\tfont-weight: 700;\r\n\tfont-size: 32px;\r\n\tline-height: 38px;\r\n\tcolor: #d32f2f;\r\n\tmargin: 0 0 8px;\r\n\ttext-transform: none;\r\n\ttext-shadow: 0 1px 2px rgba(211, 47, 47, 0.1);\r\n}\r\n\r\n.subtitle {\r\n\tfont-size: 16px;\r\n\tcolor: #64748b;\r\n\tmargin: 0 0 32px;\r\n\tline-height: 1.6;\r\n\tmax-width: 420px;\r\n\tmargin-left: auto;\r\n\tmargin-right: auto;\r\n}\r\n\r\n.footer {\r\n\tdisplay: flex;\r\n\tjustify-content: center;\r\n\tgap: 16px;\r\n\tmargin-top: 8px;\r\n}\r\n\r\n@media screen and (max-width: 767px) {\r\n\t.modal {\r\n\t\tpadding: 28px 24px;\r\n\t\twidth: 90%;\r\n\t\tborder-radius: 12px;\r\n\t}\r\n\r\n\t.closeBtn {\r\n\t\twidth: 36px !important;\r\n\t\theight: 36px !important;\r\n\t\ttop: 12px;\r\n\t\tright: 12px;\r\n\r\n\t\timg {\r\n\t\t\twidth: 16px !important;\r\n\t\t}\r\n\t}\r\n\r\n\t.iconCircle {\r\n\t\twidth: 56px;\r\n\t\theight: 56px;\r\n\t\tmargin-bottom: 20px;\r\n\r\n\t\timg {\r\n\t\t\twidth: 24px;\r\n\t\t\theight: 24px;\r\n\t\t}\r\n\t}\r\n\r\n\t.title {\r\n\t\tfont-size: 24px;\r\n\t\tline-height: 30px;\r\n\t}\r\n\r\n\t.subtitle {\r\n\t\tfont-size: 14px;\r\n\t\tmargin-bottom: 24px;\r\n\t}\r\n\r\n\t.footer {\r\n\t\tflex-direction: column;\r\n\t\tgap: 12px;\r\n\t}\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"backdrop": `DeleteModal_backdrop__ae5W7`,
	"modal": `DeleteModal_modal__jnEdj`,
	"modalSlideIn": `DeleteModal_modalSlideIn__5QNHu`,
	"closeBtn": `DeleteModal_closeBtn__O8yGf`,
	"iconCircle": `DeleteModal_iconCircle__uwJJH`,
	"iconPulse": `DeleteModal_iconPulse__nGYsn`,
	"title": `DeleteModal_title__MBe11`,
	"subtitle": `DeleteModal_subtitle__kHy-2`,
	"footer": `DeleteModal_footer__Oo+Wh`
};
export default ___CSS_LOADER_EXPORT___;
